const parseDateOnlyUtc = (value) => {
    const normalized = String(value || '').slice(0, 10);
    if (!/^\d{4}-\d{2}-\d{2}$/.test(normalized)) return null;
    const [year, month, day] = normalized.split('-').map(Number);
    const parsed = new Date(Date.UTC(year, month - 1, day));
    return Number.isNaN(parsed.getTime()) ? null : parsed;
};

const dateToKey = (date) => {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const nightsBetween = (start, end) => {
    if (!start || !end || end <= start) return 0;
    return Math.max(1, Math.round((end.getTime() - start.getTime()) / 86400000));
};

const getPropertyBookingStats = (bookings, year, acquisitionDate, now = new Date()) => {
    const normalizedYear = Number(year);
    const validBookings = Array.isArray(bookings)
        ? bookings.filter((booking) => {
            const start = parseDateOnlyUtc(booking.startDate);
            const end = parseDateOnlyUtc(booking.endDate);
            return !!start && !!end && end > start;
        })
        : [];

    const yearStart = new Date(Date.UTC(normalizedYear, 0, 1));
    const yearEnd = new Date(Date.UTC(normalizedYear + 1, 0, 1));
    const bookedDayKeys = new Set();

    validBookings.forEach((booking) => {
        const start = parseDateOnlyUtc(booking.startDate);
        const end = parseDateOnlyUtc(booking.endDate);
        if (!start || !end || end <= start) return;
        if (end <= yearStart || start >= yearEnd) return;

        const cursor = new Date(start > yearStart ? start : yearStart);
        const rangeEnd = end < yearEnd ? end : yearEnd;
        while (cursor < rangeEnd) {
            bookedDayKeys.add(dateToKey(cursor));
            cursor.setUTCDate(cursor.getUTCDate() + 1);
        }
    });

    const acquisitionDateUtc = parseDateOnlyUtc(acquisitionDate);
    const occupancyWindowStart = acquisitionDateUtc && acquisitionDateUtc > yearStart ? acquisitionDateUtc : yearStart;
    const currentYear = now.getUTCFullYear();
    const occupancyWindowEnd = normalizedYear === currentYear
        ? new Date(Date.UTC(currentYear, now.getUTCMonth(), now.getUTCDate() + 1))
        : yearEnd;
    const occupancyWindowDays = Math.max(0, Math.round((occupancyWindowEnd.getTime() - occupancyWindowStart.getTime()) / 86400000));

    let bookedNightsInOccupancyWindow = 0;
    bookedDayKeys.forEach((dayKey) => {
        const day = parseDateOnlyUtc(dayKey);
        if (!day) return;
        if (day >= occupancyWindowStart && day < occupancyWindowEnd) {
            bookedNightsInOccupancyWindow += 1;
        }
    });

    const totalBookingAmountAllTime = validBookings.reduce((sum, booking) => sum + (Number(booking.amount) || 0), 0);
    const totalNightsAllTime = validBookings.reduce((sum, booking) => {
        const start = parseDateOnlyUtc(booking.startDate);
        const end = parseDateOnlyUtc(booking.endDate);
        return sum + nightsBetween(start, end);
    }, 0);

    return {
        occupancyRate: occupancyWindowDays ? (bookedNightsInOccupancyWindow / occupancyWindowDays) * 100 : 0,
        averageBookingAmount: validBookings.length ? totalBookingAmountAllTime / validBookings.length : 0,
        averageBookingNightAmount: totalNightsAllTime ? totalBookingAmountAllTime / totalNightsAllTime : 0,
        bookedNightsInYear: bookedDayKeys.size
    };
};

export {
    getPropertyBookingStats,
    parseDateOnlyUtc,
    nightsBetween,
    dateToKey
};